import { Pagination, styled, Theme } from '@mui/material';
import { palette } from 'view/themes/palette';

export const CustomPagination = styled(Pagination)(({ theme }: { theme: Theme }) => {
  return {
    '.MuiButtonBase-root': {
      '&:hover': {
        backgroundColor: palette.hover.background,
      },
    },

    '.Mui-selected': {
      backgroundColor: 'transparent!important',
      color: palette.primary.purple500,
      border: `1px solid ${palette.primary.purple500}`,
      pointerEvents: 'none',
      cursor: 'not-allowed',

      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  };
}) as typeof Pagination;
